import { IntlProvider } from "react-intl";

import enMessages from "./messages/en.json";
import trMessages from "./messages/tr.json";

import { useContext } from "react";
import { AppContext } from "../context/AppContext";

const allMessages = {
  en: enMessages,
  tr: trMessages,
};

export default function I18nProvider({ children }) {
  const { locale = "en" } = useContext(AppContext);
  const messages = allMessages[locale];
  return (
    <IntlProvider locale={locale} messages={messages} onError={() => {}}>
      {children}
    </IntlProvider>
  );
}
